var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3842 37.6813H29.2499L29.5 33.662H24.1159V10.5687L29.25 10.5687L29.25 6.84507L15.8047 6.84507V10.5687L20.3842 10.5687V37.6813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2499 37.6813L29.2501 45H45V27.3127H29.2501L29.25 33.662L29.2499 37.1789V37.6813Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2501 0L29.25 6.84507L29.2501 17.6873H45V0H29.2501Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 10.5687V6.84507V0H0V17.6873H15.8047V10.5687Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3842 37.6813H29.2499L29.5 33.662H24.1159V10.5687L29.25 10.5687L29.25 6.84507L15.8047 6.84507V10.5687L20.3842 10.5687V37.6813Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2499 37.6813L29.2501 45H45V27.3127H29.2501L29.25 33.662L29.2499 37.1789V37.6813Z",
    fill: "#256BE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2501 0L29.25 6.84507L29.2501 17.6873H45V0H29.2501Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 10.5687V6.84507V0H0V17.6873H15.8047V10.5687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.da3f8542d70d092ba9a839d661b54c50.svg";
export { ForwardRef as ReactComponent };